
import InfoUpdate from "@/modules/core/pages/InfoUpdate";
import Tools from '@/modules/core/pages/Services'
import LoadSys from '@/modules/core/pages/LoadSys'
import {isAuthenticated} from "../../helper";


export default ([


  {
    path: '',
    name: 'Main',
    component: LoadSys,
    meta: {
      breadcrumb: 'Main',
    },
    beforeEnter: (to, from, next) => {
      if (isAuthenticated())
        next({
          name: 'OpenDiss',
        });
      else
        next()
    }
  },
  {
    path: '/tools',
    name: 'Tools',
    component: Tools,
    meta: {
      breadcrumb: 'Сервисы',
    }
  },

])


